export const tabTitles = [
  { key: "picture", value: "Fotoğraflar", ga4Label: "fotoğraf" },
  { key: "video", value: "Video", ga4Label: "video" },
  { key: "three-d", value: "3D Tur", ga4Label: "3d-tur" },
  { key: "map", value: "Harita/Konum Bilgisi", ga4Label: "harita" },
];
